export enum UserType {
  EMPLOYEE = 'EMPLOYEE',
  DEALER = 'DEALER',
  REGIONAL = 'REGIONAL',
}
